// src/stone/icons/Headset.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Headset = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 25",
    ...props,
    children: [
      /* @__PURE__ */ jsxs("g", { stroke: "currentcolor", clipPath: "url(#headset_svg__a)", children: [
        /* @__PURE__ */ jsx("path", { d: "M14 23.184h5a3 3 0 0 0 3-3v-3M7 12.184H2v5a2 2 0 0 0 2 2h3z" }),
        /* @__PURE__ */ jsx("path", { d: "M22 12.184h-5v7h3a2 2 0 0 0 2-2zM22 12.184v-1c0-5.523-4.477-10-10-10s-10 4.477-10 10v1" })
      ] }),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "headset_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M0 .184h24v24H0z" }) }) })
    ]
  }
);
var Headset_default = Headset;

export {
  Headset,
  Headset_default
};
